// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__-u+6z","child1":"footer_child1__lFShP"};